module.exports = __webpack_public_path__ + "img/star_5.9726152b.png";